import * as React from 'react';
import { Field, Form, Formik, FormikHelpers as FormikActions } from 'formik';
import { PrimaryButton } from '@magoosh/lib/button';
import { adminPaths } from 'config/path_helpers';
import fetch from 'utilities/fetch';
import { LiveClass } from '@magoosh/admin/live_class_sessions/types';

interface FormProps {
  liveClass?: LiveClass;
  runQuery: any;
  closeModal: () => void;
}

interface LiveClassFormValues {
  name: string;
}

const LiveClassForm: React.FC<FormProps> = (props) => {
  const initialValues: LiveClassFormValues = {
    name: ''
  };

  if (props.liveClass) {
    initialValues.name = props.liveClass.name;
  }

  const onSubmitForm = (
    values: LiveClassFormValues,
    { setSubmitting }: FormikActions<LiveClassFormValues>
  ) => {
    setSubmitting(true);

    fetch(props.liveClass ? adminPaths.api.liveClass(props.liveClass.id) : adminPaths.api.liveClasses(), {
      method: props.liveClass ? 'PATCH' : 'POST',
      body: JSON.stringify(values)
    })
      .then((response) => {
        props.closeModal();
        props.runQuery();
      })
      .catch((response) => alert(response.errors._error))
      .finally(() => setSubmitting(false));
  };

  return (
    <Formik onSubmit={onSubmitForm} initialValues={initialValues}>
      {({ values, isSubmitting, submitForm }) => (
        <Form>
          <div>
            <label htmlFor="live-class-name">Name</label>
            <Field name="name" className="form-control u-margin-B-s" id="liveClass-name" label="Name" />
            <PrimaryButton className="u-margin-T-s" submitting={isSubmitting} onClick={submitForm}>
              Submit
            </PrimaryButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default LiveClassForm;
